export enum ModalStyle {
  Popup = 'popup',
  Form = 'form',
  Loader = 'loader',
}
